<mat-form-field class="app-password-input">
    <input
        matInput
        #input
        autocomplete="off"
        [placeholder]="asFormsControl().placeholder"
        [disabled]="disabled"
        [type]="passwordInputType"
        (focus)="onTouched && onTouched()"
        (keyup)="changeValue($event)"
    >
    <span
        matSuffix
        class="app-password-input-suffix icon-closed-eye"
        [ngClass]="{'changed': passwordInputType === inputComponentTypes.Text}"
        (click)="changePasswordInputType($event)"
    ></span>
    <mat-hint
        *ngIf="asFormsControl().errors.length === 0 && !asFormsControl().hintDisabled"

        [ngClass]="{'valid': !asFormsControl().invalid}"

        align="start"

        class="app-password-input-hint"
    >
        Minimum 8 characters • Uppercase letter <br>
        Lowercase letter • Special symbol • Number
    </mat-hint>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
